import React, { useState } from "react";
import DialogModifyCliente from "./DialogModifyCliente";

import EditIcon from '@mui/icons-material/Edit';
import { Delete } from "@mui/icons-material";

import { TableRow, TableCell, IconButton, Box, Button, DialogActions, DialogContentText, Dialog, DialogTitle, DialogContent, useTheme } from "@mui/material";
import { getPersistentRowHighlightSx } from "../../../utils/rowHighlights";

const RowTableCliente = ({data, handleDelete, handleUpdateData, areUserAdmin, searchHighlighted}) => {
  const theme = useTheme();
  const [openAlertDelete, setOpenAlertDelete] = useState(false);
  const [openModifyDialog, setOpenModifyDialog] = useState(false);
  
  const handleOpenModifyDialog = () => { setOpenModifyDialog(true) }
  const handleCloseModifyDialog = () => { setOpenModifyDialog(false) }

  return (
    <React.Fragment>
      { areUserAdmin && <Dialog
        open={openAlertDelete}
        keepMounted
        onClose={() => {setOpenAlertDelete(false)}}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Espera un Segundo!"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Estás apunto de eliminar este Vehiculo del Registro de Vehiculos de este parqueadero
            ¿Estás seguro de que quieras hacer esto?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {setOpenAlertDelete(false)}} color='error' variant="outlined">No</Button>
          <Button onClick={() => {setOpenAlertDelete(false); handleDelete(data.id); }} variant="contained">¡Sí!</Button>
        </DialogActions>
      </Dialog>}

      <TableRow
        aria-label={searchHighlighted ? 'Coincidencia destacada de búsqueda' : undefined}
        data-search-highlight={searchHighlighted ? 'true' : undefined}
        sx={getPersistentRowHighlightSx(theme, false, searchHighlighted)}
      >
        <TableCell component="th" scope="row" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd' }}> {data.id} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd' }}> {data.nombre} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd'}}> {data.apellidos} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd'}}> {data.tipo_documento} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd'}}> {data.documento} </TableCell>
        <TableCell align="left" sx={{ borderLeft: '2px solid #ddd', borderBottom: '2px solid #ddd', borderRight: areUserAdmin ? null : '2px solid #ddd'}}> {data.celular} </TableCell>
        {areUserAdmin && <TableCell sx={{ borderLeft: '2px solid #ddd', borderRight: '2px solid #ddd', borderBottom: '2px solid #ddd'}}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <IconButton
                size="large"
                onClick={() => {handleOpenModifyDialog()}}
                sx={{ color: '#33eaff', padding: 0, border: '2px solid #33eaff' }}
              >
                <EditIcon sx={{ fontSize: '33px' }}/>
              </IconButton>
              <IconButton
                size="large"
                onClick={() => { setOpenAlertDelete(true) }} // Se ejecuta la eliminación
                sx={{ color: '#d32f2f', padding: 0, border: '2px solid #d32f2f' }}
              >
                <Delete sx={{ fontSize: '33px' }}/>
              </IconButton>
          </Box>
        </TableCell>}
      </TableRow>

      { areUserAdmin&& <DialogModifyCliente
        openDialog={openModifyDialog}
        handleCloseDialog={handleCloseModifyDialog}
        data={data}
        handleUpdateData={handleUpdateData}
      /> }

    </React.Fragment>
  );
}

export default RowTableCliente;
